// data
import couponTypeEnum from '../coupon/couponTypeEnum';
import externalApp  from '@data/externalApp';

// api
import storageManager from '../platformApi/storageManager';
import paymentManager from '../platformApi/paymentManager';
import requestManager from '../platformApi/requestManager';
import timerManager   from '../platformApi/timerManager';
// import locationManager  from '../platformApi/locationManager';
import consoleApi       from "../platformApi/consoleApi";

import payApi       from "../deal/payApi";
import userApi       from "@/api/user";

// util
import consoleHelper    from '@/util/consoleHelper';
import objectHelper     from '@/util/objectHelper';
import appHelper        from '@/util/appHelper';
import browserHelper from "@util/browserHelper";
import userUtil from "@comp/shixunApp/userUtil";

/**
 * 支付组件零件
 * @module  part/payComp
 * @description 包含优惠券功能、支付协议同意检查、完善信息
 */
export default {
    props : {

        /**
         * @member          onPaySuccess
         * @description     (component property) onPaySuccess
         * @type            {Function}
         * @example     <payDialog :onPaySuccess="">
         */
        onPaySuccess : Function,

        onSubmitOrderFail : Function,

        /**
         * @member          type
         * @description     (component property) type
         * @type            {String}
         * @example     <payDialog type="prepay">
         */
        type : {
            type : String,
            default : 'normal'
        },

        // Available values : RMB, GOLD, INTEGRAL, IPA
        coinType : {
            type : String,
            default : 'RMB'
        } ,
        agreeServiceName :{
            type: String,
            default: '师讯平台用户协议'
        },
        agreeServiceUrl:{
            type: String,
            default: ''
        }

    },
    data() {
        return {
            /**
             * 货币类型，默认为 '￥'
             * @type {String}
             */
            currencyType : '￥',

            /**
             * 价格
             * @type {Number}
             */
            price : 0,
            /**
             * 价格
             * @member product
             * @type {Object}
             * @example {
             *      id : '1',
             *      title : '商品',
             *      image : '...',
             *      price : '0.99',
             * }
             */
            product : {
                id : '',
                title : '',
                image : '',
                price : '',
            },
            /**
             * pay operation status, loading | complete | error
             * @type    {String}
             */
            status : '',

            /**
             * pay success status
             * @type    {Boolean}
             */
            payStatus:false,

            orderId:'',

            enableCoupon : true,

            /**
             * @type {Array}
             */
            couponList : [],

            /**
             * @type {Null|Object}
             */
            selectedCoupon : null,

            couponTypeEnum : couponTypeEnum,

            contents : {
                pay : {
                    title : '确认支付'
                },
                coupon : {
                    title : '选择优惠券'
                },
                fillInContactInformation : {
                    title : '完善信息'
                }
            },
            currentContent : null,

            /**
             * @type {Boolean}
             */
            needFillInContactInformation : false,
            submitedContactInformation : false,

            formFields : [],
            /** 协议 **/
            agreeServiceProtocol: false,

            externalApp: externalApp,

            contactInformationFormData : {},

            // 临时的，检查手机绑定
            isBindPhone : false
        }
    },
    methods : {

        checkNeedFillInContactInformation() {

            const me = this;

            let bizType = this.product.bizType || '';
            if (!bizType)
            {
                return;
            }

            payApi.isNeedCollectInfo({
                bizId : this.product.id,
                bizType : this.product.bizType
            }, (result) => {
                this.needFillInContactInformation = result.data.isNeed;
                this.submitedContactInformation = result.data.oldForm;
                consoleApi.log('[payComp] 是否需要完善联系信息：' + (this.needFillInContactInformation ? '是' : '否'));

                if (this.needFillInContactInformation)
                {
                    consoleApi.log('[payComp] 提交过的联系信息：' + (this.submitedContactInformation ? '' : '没有'));
                    if (this.submitedContactInformation)
                    {
                        consoleApi.log(this.submitedContactInformation);
                    }
                    // consoleApi.log('[payComp] 需要收集联系信息。');

                    this.formFields = result.data.formData;

                    let addressFieldIds = [];

                    for (let i=0; i<this.formFields.length; i++)
                    {
                        let tField = this.formFields[i];
                        this.contactInformationFormData[tField.field] = tField.value || '';
                        if (tField.fieldType === 'ADDRESS')
                        {
                            addressFieldIds.push(tField.field);
                        }
                    }

                    // if (addressFieldIds.length)
                    // {
                    //     locationManager.getLocation({}, (error, result) => {
                    //
                    //         let latitude    = result.latitude; // 纬度，浮点数，范围为90 ~ -90
                    //         let longitude   = result.longitude; // 经度，浮点数，范围为180 ~ -180。
                    //
                    //         let geocoder = new qq.maps.Geocoder();
                    //
                    //         geocoder.setComplete(function(result) {
                    //
                    //             consoleHelper.log(result);
                    //             consoleHelper.log(result.detail.address);
                    //
                    //             for (let i=0; i < addressFieldIds.length; i++)
                    //             {
                    //                 me.contactInformationFormData[addressFieldIds[i]] = result.detail.address;
                    //             }
                    //         });
                    //         //若服务请求失败，则运行以下函数
                    //         geocoder.setError(function() {
                    //             consoleHelper.log("[payComp] 地理位置地址查询失败");
                    //         });
                    //
                    //         geocoder.getAddress(new qq.maps.LatLng(latitude, longitude));
                    //     });
                    // }
                }
            });
        },
        cancel() {
            this.currentContent = this.contents.pay;
            this.close();
        },

        /**
         * @method  loadCouponList
         */
        loadCouponList : function () {
            consoleHelper.log('[payComp] load coupon list.');
            const me = this;

            requestManager.request({
                url : this.apiConfig.couponList.url,
                method : this.apiConfig.couponList.method || 'get',
                params : this.apiConfig.couponList.params || {},
            }, (error, result) => {

                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                me.couponList = result.data;

                // do not auto select first coupon
                // if (me.couponList && !me.selectedCoupon)
                // {
                //     me.selectedCoupon = me.couponList[0];
                // }
            });
        },

        /**
         * @method  setProduct
         * @param   {Object}    productData
         */
        setProduct : function (productData) {

            // check if need fill in contact information

            for (let key in productData)
            {
                this.product[key] = productData[key];
            }

            if (this.apiConfig.couponList || null)
            {
                this.apiConfig.couponList.params.bizId = productData.id || '';
                this.apiConfig.couponList.params.sourcePrice = productData.price || 0;
                productData.price ? this.loadCouponList() : null;
            }
            this.calculatePrice();

            this.checkNeedFillInContactInformation();
        },

        saveContactInformation() {
            consoleHelper.log('[payComp] form data:');
            consoleHelper.log(this.contactInformationFormData);

            for (let i=0; i < this.formFields.length; i++)
            {
                let tField = this.formFields[i];
                let tKey = tField.field;
                if (tField.required && this.contactInformationFormData[tKey] === '')
                {
                    appHelper.showHint('请填写完整信息');
                    return;
                }
            }

            let data = JSON.stringify(this.contactInformationFormData);

            payApi.submitCollectInfo({
                bizId : this.product.id,
                bizType : this.product.bizType,
                payInfo : data
            }, (result) => {
                appHelper.showHint('保存成功');

                // back to pay view
                this.currentContent = this.contents.pay;

                // reload contactInformation
                this.checkNeedFillInContactInformation();
            });
        },

        /**
         * @method  clickCoupon
         * @param   {Object}    couponItem
         */
        clickCoupon : function (couponItem) {
            if (!couponItem.isUse)  // can not use
            {
                return;
            }
            this.selectedCoupon = couponItem;
            this.currentContent = this.contents.pay;
            this.calculatePrice();
        },

        /**
         * @method  calculatePrice
         */
        calculatePrice : function () {

            if (!this.product)
            {
                this.price = 0;
                return;
            }

            if (this.selectedCoupon)
            {
                this.price = this.selectedCoupon.afterDiscountAmount;
                consoleApi.log('[payComp] 使用优惠券：￥' + this.price + '');
            }
            else
            {
                this.price = this.product.price;
                consoleApi.log('[payComp] 使用优惠券：￥' + this.price + '');
            }
        },

        /**
         * @method  pay
         */
        pay : function () {

            const me = this;

            if (this.needFillInContactInformation && !this.submitedContactInformation)
            {
                appHelper.showHint('请先完善个人信息');
                return;
            }

            if( !this.agreeServiceProtocol){
                // appHelper.showHint('请先勾选服务协议');
                appHelper.showHint('请阅读并勾选同意' + this.agreeServiceName);
                return;
            }

            // if (!this.isBindPhone)
            // {
            //     appHelper.confirm({
            //         title : '身份验证',
            //         content : '介于师讯平台做了大的升级，为了保证您的正常使用，希望您进行身份验证，非常感谢！',
            //         okText : '去认证',
            //         cancelText : '我再想想'
            //     }, (status) => {
            //         if (!status)
            //         {
            //             return;
            //         }
            //
            //         appHelper.goToPage('bindPhone');
            //     });
            //     return;
            // }

            this.submitOrder(function(result,info){
                const payWay = paymentManager.getPaymentWay();
                let data = result.data;

                const orderId = data.orderId;
                if (typeof (data.jssdkPayConfig) === 'undefined')
                {
                    // {
                    //     "errorCode": 0,
                    //     "msg": null,
                    //     "data": {
                    //         "orderId": "dbc887beafe34368b59d0f23fcd2f46e"
                    //     }
                    // }
                    // not need pay
                    me.onPaySuccess(data, orderId);
                    return;
                }
                const payParams = data.jssdkPayConfig;
                me.orderId = orderId;
                // 微信小程序环境
                wx.miniProgram.getEnv((res)=>{
                    if (res.miniprogram) {
                        wx.miniProgram.getEnv(function(res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                var pid=(payParams.package).split('=')[1];
                                var params = '?timeStamp='+payParams.timestamp
                                    +'&package='+pid
                                    +'&paySign='+payParams.paySign
                                    +'&signType='+payParams.signType
                                    +'&nonceStr='+payParams.nonceStr + '&orderId='+orderId + '&bizType=' + info.orderBizType  ;
                                var payurl='/pages/pay/pay'+params;
                                wx.miniProgram.navigateTo({url: payurl});
                                /** 跳转小程序支付，支付成功后会跳转到支付成功界面进行结算 **/
                                //监听 -> 1.搞个loading图标：结算中 ， 2.定时器轮训3一次：去请求后台有没有成功 ，如果成功了就当作是支付成功（旧逻辑） /超过10秒当作失败提示，支付失败或稍后
                                // timerManager.setInterval(()=>{
                                //     alert("监听！")
                                // },3000)
                            }
                        });
                    } else {
                        // alert("不在小程序里");
                    }
                })


                if (payWay === 'H5')
                {
                    wx.chooseWXPay({
                        timestamp: payParams.timestamp,// 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: payParams.nonceStr, // 支付签名随机串，不长于 32 位
                        package: payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                        signType: payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: payParams.paySign, // 支付签名
                        success: function (res) {// 支付成功, res 示例值 {"errMsg": "chooseWXPay:ok"}
                            me.getPayStatus(orderId, function (result) {
                                ;
                            });

                            timerManager.setTimeout(() => {
                                me.onPaySuccess({
                                    orderId : orderId
                                });
                            }, 2 * 1000);

                        },
                        cancel: function (res) {// 支付取消, res 示例值 {"errMsg": "chooseWXPay:cancel"}

                        },
                        fail: function (res) {// 支付失败, res 示例值 {"errMsg": "chooseWXPay:fail"}
                            appHelper.showHint("支付失败: " + res.errMsg);
                        },
                        complete: function (res) {// 不管什么状态, 最终都会调用

                        }
                    });

                    if (!browserHelper.isWechat)
                    {
                        appHelper.showHint('请使用微信环境进行支付');
                    }
                }
                else
                {
                    consoleHelper.log('[payComp] payWay: ' + payWay + ' unknown to do.');
                }
            });
        },

        /**
         * @method  submitOrder
         * @param   {Function}  callback
         */
        submitOrder : function (callback)
        {
            const me = this;

            if (this.status === 'loading')
            {
                consoleHelper.info('[payComp] already loading.');
                return;
            }

            // submit order
            consoleApi.log('[payComp] submit order');
            this.status = 'loading';
            let adId = storageManager.getItem('ad_sessino_key') || '';

            const promotionCode = storageManager.getItem('promotion_from') || '';

            let url = '';
            let method = '';
            let idName = '';
            let params = {};
            if (this.type === 'prepay_combo')
            {
                url = this.apiConfig.prepayCombo.url;
                method = this.apiConfig.prepayCombo.method || 'get';
                idName = this.apiConfig.prepayCombo.idName || 'id';
                params = objectHelper.clone(this.apiConfig.prepayCombo.params || {});
            }
            else if (this.type === 'prepay')
            {
                url = this.apiConfig.prepayOrder.url;
                method = this.apiConfig.prepayOrder.method || 'get';
                idName = this.apiConfig.prepayOrder.idName || 'id';
                params = objectHelper.clone(this.apiConfig.prepayOrder.params || {});
            }
            else if (this.type === 'secondKill')
            {
                url = this.apiConfig.secondKill.url;
                method = this.apiConfig.secondKill.method || 'get';
                idName = this.apiConfig.secondKill.idName || 'id';
                params = objectHelper.clone(this.apiConfig.secondKill.params || {});
            }
            else if (this.type === 'payVip')
            {
                url = this.apiConfig.payVip.url;
                method = this.apiConfig.payVip.method || 'get';
                idName = this.apiConfig.payVip.idName || 'id';
                params = objectHelper.clone(this.apiConfig.payVip.params || {});
            }
            else if (this.type === 'miniCourseWare')
            {
                url = this.apiConfig.miniCourseWare.url;
                method = this.apiConfig.miniCourseWare.method || 'get';
                idName = this.apiConfig.miniCourseWare.idName || 'id';
                params = objectHelper.clone(this.apiConfig.miniCourseWare.params || {});
                params.payMessage = me.product.payMessage;
            }
            else if (this.type === 'thirdService')
            {
                url = this.apiConfig.thirdService.url;
                method = this.apiConfig.thirdService.method || 'get';
                idName = this.apiConfig.thirdService.idName || 'id';
                params = objectHelper.clone(this.apiConfig.thirdService.params || {});
            }
            else if (this.type === 'agencyBalance')
            {
                url = this.apiConfig.agencyBalance.url;
                method = this.apiConfig.agencyBalance.method || 'get';
                idName = this.apiConfig.agencyBalance.idName || 'id';
                params = objectHelper.clone(this.apiConfig.agencyBalance.params || {});
            }
            else if (this.type === 'normal')
            {
                url     = this.apiConfig.submitOrder.url;
                method  = this.apiConfig.submitOrder.method || 'get';
                idName  = this.apiConfig.submitOrder.idName || 'id';
                params  = objectHelper.clone(this.apiConfig.submitOrder.params || {});
            }
            else
            {
                if (typeof(this.apiConfig[this.type]) === 'undefined')
                {
                    consoleApi.error('pay api config not defined with type: ' + this.type);
                    return;
                }
                let config = this.apiConfig[this.type];
                url     = config.url;
                method  = config.method || 'get';
                idName  = config.idName || 'id';
                params  = objectHelper.clone(config.params || {});
            }

            let data = objectHelper.merge(params, {
                payWay: paymentManager.getPaymentWay(),
                promotionCode : promotionCode,
                adId: adId,
                couponNo: this.selectedCoupon ? this.selectedCoupon.couponId : null,
                coinType : this.coinType
            });

            consoleApi.log('[payComp] promotionCode: ' + data.promotionCode);
            consoleApi.log('[payComp] adId: ' + data.adId);
            consoleApi.log('[payComp] couponNo: ' + data.couponNo);
            consoleApi.log('[payComp] coinType: ' + data.coinType);

            data[idName] = me.product.id;

            requestManager.request({
                url : url,
                method : method,
                data: data,
            }, (error, result) => {

                if (error)
                {
                    appHelper.generalAjaxError(error);
                    me.status = 'error';
                    return;
                }
                me.status = 'complete';

                if (result.errorCode) {

                    me.status = 'error';
                    if (this.onSubmitOrderFail)
                    {
                        this.onSubmitOrderFail(result);
                    }
                    else
                    {
                        appHelper.showHint(result.msg);
                    }
                    return;
                }

                if (callback)
                {
                    callback(result,data);
                }

            });

        },

        /**
         * @method  getPayStatus
         * @param   {String}    orderId
         * @param   {Function}  callback
         */
        getPayStatus : function (orderId, callback)
        {
            const me = this;
            me.status = 'loading';

            requestManager.request({
                url: this.apiConfig.getPayStatus.url,
                method : this.apiConfig.getPayStatus.method || 'GET',
                data: {
                    orderId: orderId
                }
            }, (error, result) => {

                // if (error)
                // {
                //     appHelper.generalAjaxError(error);
                //     me.status = 'error';
                //     return;
                // }

                me.status = 'complete';
                me.payStatus = true;

                // if (result.errorCode) {
                //
                //     consoleHelper.error(result.msg);
                //
                //     // errorCode 为1，忽略
                //     if (result.errorCode != 1)
                //     {
                //         appHelper.showHint(result.msg);
                //         return;
                //     }
                // }

                if (callback)
                {
                    callback(result);
                }
            });
        }
    },
    mounted() {

        const me = this;

        appHelper.checkLogin((error, userData) => {

            if (error) {
                return;
            }

            if (!userData) {    // 游客
                return;
            }

            userApi.getBindPhoneStatus((status) => {
                me.isBindPhone = status;
                status ? consoleApi.log('[user] 已绑定手机，无须进行认证。')
                       : consoleApi.log('[user] 未绑定手机，需要进行认证。');
            });

        });


    }
}

